
    module.exports = {
      render: function(){with(this){return _c('div',{staticClass:"form-group",class:{invalid: errors, required: required}},[_c('label',{attrs:{"for":"date"}},[_v(_s(label_text))]),_c('datetime',{attrs:{"format":"MM/DD/YYYY","lang":"en","type":"date"},on:{"change":updateDatetime},model:{value:(value),callback:function ($$v) {value=$$v},expression:"value"}}),(errors)?[_c('div',{staticClass:"errors"},[_v("Scheduled at "+_s(errors.join(", "))+".")])]:_e()],2)}},
      staticRenderFns: []
    };
  